import React, { useContext } from "react";
import { Menu, Container, Button, Dropdown, Image } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { Link, NavLink } from "react-router-dom";
import { RootStoreContext } from "../../app/stores/rootStore";


const NavBarProject: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { user, logout } = rootStore.userStore;
  return (
    <Menu fixed="top" inverted style={{ marginLeft: '12%' }}>
        <Menu.Item as={NavLink} to="/projectmanagement/project">
          BDOD
        </Menu.Item>
        <Menu.Item as={NavLink} to="/projectmanagement/mobile">
          Mobile
        </Menu.Item>
        <Menu.Item as={NavLink} to="/projectmanagement/minor">
          Minor
        </Menu.Item>
        <Menu.Item as={NavLink} to="/projectmanagement/transmission">
          Transmission
        </Menu.Item>
        <Menu.Item as={NavLink} to="/projectmanagement/sitevodafone">
          Site
        </Menu.Item>
        {user && (
          <Menu.Item position="right" style={{ marginRight: '17%' }}>
            <Image
              avatar
              spaced="right"
              src={user.image || "/assets/user.png"}
            />
            <Dropdown pointing="top left" text={user.displayName}>
              <Dropdown.Menu>
                <Dropdown.Item
                  as={Link}
                  to={`/employeeportal/profile`}
                  text="My profile"
                  icon="user"
                />
                <Dropdown.Item
                  as={Link}
                  to={`/employeeportal/certificate`}
                  text="My certificate"
                  icon="user"
                />
                <Dropdown.Item
                  as={Link}
                  to={"/employeeportal/assets"}
                  text="My Assets"
                  icon="user"
                />
                <Dropdown.Item onClick={logout} text="Logout" icon="power" />
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        )}
    </Menu>
  );
};

export default observer(NavBarProject);
